var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.6484 11.75H7.71875V20.5H3.8125V11.75H0.648438V8.11719H3.8125V5.38281C3.8125 4.34115 4.00781 3.45573 4.39844 2.72656C4.78906 1.9974 5.33594 1.45052 6.03906 1.08594C6.76823 0.695312 7.60156 0.5 8.53906 0.5C8.95573 0.5 9.39844 0.526042 9.86719 0.578125C10.3359 0.604167 10.7005 0.643229 10.9609 0.695312L11.3516 0.734375V3.82031H9.78906C9.0599 3.82031 8.52604 4.01562 8.1875 4.40625C7.875 4.77083 7.71875 5.22656 7.71875 5.77344V8.11719H11.1953L10.6484 11.75Z"}));
}

Facebook.defaultProps = {"viewBox":"0 0 12 21"};

module.exports = Facebook;

Facebook.default = Facebook;
